import React from "react";
import ForgetPasswordComponent from "../../../features/auth/forgetPassword/ForgetPassword";
function ForgetPassword() {
  return (
    <div>
      <ForgetPasswordComponent />
    </div>
  );
}

export default ForgetPassword;
